import { graphql } from "react-relay";

export const StopJobRunMutation = graphql`
  mutation StopJobRunMutation($input: StopJobRunInput!) {
    stopJobRun(input: $input) {
      success
      jobRun {
        id
        status
      }
    }
  }
`;
